<template>
  <div class="ForgetPasswd">
    <div class="LoginContentWrap FindPassword">
      <div class="LoginTitle"><p><strong>Hello!</strong> 修改密码...</p></div>
      <div class="InputWrap flexbetween">
        <div class="CloseBox" @click="closeWindow"><img src="../assets/Home/exit1.png"></div>
        <div class="CodeWrap">
          <i><img src="../assets/Home/logo1.png"></i>
        </div>
        <div class="InputContentWrap">
          <div class="Password">
            <div class="Phone">
              <div class="Input flexa"><input placeholder="输入手机号" disabled maxlength="11" onkeyup="value=value.replace(/[^\d]/g,'')" v-model="forgetPasswdData.phone"></div>
              <div class="Input SendCode flexa"><input placeholder="输入图形验证码" maxlength="4" onkeyup="value=value.replace(/[^\d]/g,'')" @blur="checkToShowMsgBtn" v-model="forgetPasswdData.imgCode">
                <div class="flex Send codes" @click="requestImgCode"><img :src="imgCodeSrc"></div>
              </div>
              <div class="Input SendCode flexa"><input placeholder="输入验证码" maxlength="6" onkeyup="value=value.replace(/[^\d]/g,'')" v-model="forgetPasswdData.code">
                <div class="flex Send" @click="requestMessageCode(forgetPasswdData.phone)"><span>{{Text}}</span></div>
              </div>
            </div>
            <div class="Input flexa"><input style="width: 100%" @blur="validatePasswd(forgetPasswdData.newPasswd,6,16)" autocomplete="new-password" type="password" v-model="forgetPasswdData.newPasswd" placeholder="输入新密码 (6~16位大小写字母+数字组合)"></div>
            <div class="Input SendCode flexa"><input @blur="validateConfirmPasswd" @keyup.enter="ForgetPasswdSubmit" autocomplete="new-password" placeholder="再次输入新密码" v-model="forgetPasswdData.newPasswdAgain" type="password"></div>
          </div>
          <div class="SubmitButton flex"  @click="ForgetPasswdSubmit"><span>提交</span></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import { mapGetters, mapActions } from 'vuex';
  export default {
    name: 'ChangePasswdPopWindow',
    components: {},
    props: {},
    data () {
      return {
        forgetPasswdData: {
          phone: '',
          code: '',
          imgCode: '',
          newPasswd: '',
          newPasswdAgain: '',
          regid: '',
          smsid: ''
        },
        imgCodeSrc: '',
        imgCode: '',
        noclickFlag: false,
        i: 60,
        Text: '发送验证码',
        isMsgCodeShow: false,
        reqMsgInterval: ''
      };
    },
    computed: {
      ...mapGetters(['UserInfo', 'LoginUserInfo'])
    },
    created () {
      this.requestImgCode();
      this.forgetPasswdData.phone = this.LoginUserInfo.tel;
    },
    mounted () {},
    watch: {
      'forgetPasswdData.imgCode': function (val) {
        this.isMsgCodeShow = this.forgetPasswdData.phone && val === this.imgCode;
      }
    },
    methods: {
      closeWindow() {
        this.$emit('closeWindow');
      },
      checkToShowMsgBtn() {
        this.isMsgCodeShow = this.forgetPasswdData.phone && this.forgetPasswdData.imgCode === this.imgCode;
      },
      validatePasswd(passwd) {
        let pwdRegex = new RegExp('^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\\W_!@#$%^&*`~()-+=]+$)(?![0-9\\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\\W_!@#$%^&*`~()-+=]{6,16}$');
        if (!pwdRegex.test(passwd)) {
          this.$message({
            message: '密码必须是6到16位长度且包含大写字母、小写字母、数字和特殊符号其中的四选三！',
            type: 'warning'
          });
        }
      },
      validateConfirmPasswd() {
        if (this.forgetPasswdData.newPasswd !== this.forgetPasswdData.newPasswdAgain) {
          this.$message({
            message: '两次密码输入不一致，请检查重新设置！',
            type: 'warning'
          });
        }
      },
      requestImgCode() {
        this.forgetPasswdData.regid = this.$utils.randomstring(6);
        axios({
          method: 'GET',
          headers: { 'content-type': 'application/x-www-form-urlencoded' },
          url: `${this.$userMangerUrl}user/v1/applyimgcode?regid=${this.forgetPasswdData.regid}&width=200&height=60&x=10&y=-5&jj=36&fontsize=36`
        }).then((res) => {
          if (res.status === 200 && res.data.code === 0) {
            this.imgCodeSrc = res.data.data.img;
            this.imgCode = res.data.data.code;
          }
        });
      },
      requestMessageCode(phone) {
        if (!this.noclickFlag) {
          if (this.$utils.checkPhoneNumber(phone)) {
            axios({
              method: 'GET',
              headers: { 'content-type': 'application/x-www-form-urlencoded' },
              url: `${this.$userMangerUrl}user/v1/check/${phone}/2`
            }).then((data) => {
              if (data.status === 200) {
                data = data.data;
                if (data.code === 1) {
                  this.noclickFlag = true;
                  this.reqMsgInterval = setInterval(() => {
                    if (this.i === 0) {
                      this.Text = '发送验证码';
                      this.i = 60;
                      this.noclickFlag = false;
                      clearInterval(this.reqMsgInterval);
                      return;
                    }
                    this.Text = this.i-- + 's';
                  }, 1000);
                  this.forgetPasswdData.smsid = this.$utils.randomstring(6);
                  axios({
                    method: 'GET',
                    headers: { 'content-type': 'application/x-www-form-urlencoded' },
                    url: `${this.$userMangerUrl}user/v1/smsvercode/${phone}`,
                    params: {
                      imgcode: this.forgetPasswdData.imgCode,
                      regid: this.forgetPasswdData.regid,
                      smsid: this.forgetPasswdData.smsid
                    }
                  }).then(() => {
                    this.$message({
                      message: `短信验证码已发送至手机号${phone}，请注意查收`,
                      type: 'success'
                    });
                  });
                } else if (data.code === 0) {
                  this.$message({
                    message: '手机号对应用户不存在，请注册或检查手机号重试。',
                    type: 'warning'
                  });
                }
              } else {
                this.$message.error(data.statusText);
              }
            }, err => {
              this.$message.error(err);
            });
          } else {
            this.$message({
              message: '输入的手机号不正确,请重新输入',
              type: 'warning'
            });
          }
        }
      },
      ForgetPasswdSubmit() {
        if (!this.forgetPasswdData.smsid) {
          this.$message({
            message: '请点击发送验证码',
            type: 'warning'
          });
          return;
        }

        if (!this.forgetPasswdData.code) {
          this.$message({
            message: '请输入短信验证码！',
            type: 'warning'
          });
          return;
        }
        if (this.forgetPasswdData.newPasswd !== this.forgetPasswdData.newPasswdAgain) {
          this.$message({
            message: '两次新密码输入不一致！',
            type: 'warning'
          });
          return;
        }

        axios({
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          url: `${this.$userMangerUrl}user/v1/forgetpwd`,
          data: { tel: this.forgetPasswdData.phone, smscode: this.forgetPasswdData.code, pwd: this.forgetPasswdData.newPasswd, pwd2: this.forgetPasswdData.newPasswdAgain, imgcode: this.forgetPasswdData.imgCode, regid: this.forgetPasswdData.regid, smsid: this.forgetPasswdData.smsid }
        })
          .then((response) => {
            if (response.status === 200) {
              let data = response.data;
              if (data.code === -1) {
                this.$message.error(data.msg);
              } else {
                this.$message({
                  message: '密码修改成功，请重新登录！',
                  type: 'success'
                });
                this.closeWindow();
                this.loginOut();
                this.setCurrentSystem({ code: '', name: '' });
                setTimeout(() => {
                  this.$router.push({ path: '/' });
                }, 300);
              }
            } else {
              this.$message.error(response.statusText);
            }
          })
          .catch(function (error) {
            this.$message.error(error);
          });
      },
      ...mapActions(['loginOut', 'setCurrentSystem'])
    }
  };
</script>
<style lang="scss" scoped>
@import '../../public/Value';
.ForgetPasswd {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 4;
  display: flex;
  -webkit-justify-content: center;
  -webkit-align-items: center;
  .LoginContentWrap {
    width: 2.7rem;
    height: 2.2rem;
    border-radius: 0.02rem 0.1rem 0.1rem 0.1rem;
    background: linear-gradient(to bottom right, #6666cc, #4141b3);
    position: relative;

    .CloseBox {
      width: 0.15rem;
      height: 0.15rem;
      position: absolute;
      cursor: pointer;
      right: 0.05rem;
      top: 0.05rem;
      z-index: 4;

      img {
        width: 100%;
      }
    }

    .NeedKnown {
      position: absolute;
      width: 100%;
      bottom: 0.1rem;

      p {
        font-size: $SmallTextSize;
        color: #fff;
        text-align: center;

        span {
          cursor: pointer;
          font-weight: bold;
          margin: 0 0.02rem;
          color: #999900;
        }
      }
    }

    .InputWrap {
      width: 2.4rem;
      margin: 0.1rem auto 0;

      .InputContentWrap {
        width: 50%;
        margin-top: 0.1rem;
        .TabLog {
          width: 1rem;
          margin: 0 auto 0.1rem;

          div {
            width: 50%;
            height: 0.2rem;
            cursor: pointer;
            opacity: 0.6;

            span {
              font-size: $TextSize;
              color: #fff;
            }
          }

          .Active {
            border-bottom: 3px solid #b2e4fc;
            opacity: 1;
          }
        }
        .Find{
          width: 1rem;
          margin: 0.08rem auto 0.1rem;
          p{
            font-size: $AdditionTextSize;
            color: #fff;
            margin: 0 0.05rem;
            text-align: center;
            cursor: pointer;
          }
        }
        .SubmitButton {
          width: 1rem;
          height: 0.15rem;
          border-radius: 0.3rem;
          background-color: #fff;
          margin: 0.15rem auto 0;
          cursor: pointer;
          box-shadow: 5px 5px 15px #47478c;

          span {
            font-size: $TextSize;
            color: #4848b8;
          }
        }

        .AnotherLoginWrap {
          width: 100%;

          i {
            width: 0.4rem;
            height: 2px;
            background-color: #fff;
          }

          span {
            margin: 0 0.07rem;
            font-size: $SmallTextSize;
            color: #fff;
          }

          .IconWrap {
            width: 100%;
            margin-top: 0.05rem;
            i {
              width: 0.2rem;
              height: 0.2rem;
              border-radius: 0.2rem;
              cursor: pointer;
              margin: 0 0.08rem;
              img {
                width: 100%;
                height: 100%;
                border-radius: 0.2rem;
              }
            }
          }
        }

        .Input {
          width: 1rem;
          height: 0.18rem;
          border-bottom: 2px solid #fff;
          margin: 0 auto 0.1rem;

          input {
            width: 0.6rem;
            color: #fff;
            height: 100%;
            margin-left: 0.03rem;
            font-size: $AdditionTextSize;
            background-color: rgba(255,255,255,0) !important;

            &:-webkit-autofill{
              transition: background-color 5000s ease-in-out 0s;
              -webkit-text-fill-color: #fff !important;
            }
            &:-webkit-autofill:focus {
              -webkit-text-fill-color: #fff !important;
            }
            &::-moz-placeholder{
              color: #fff;
            }
            &::-webkit-input-placeholder {
              color: #fff;
              opacity: 0.6;
              font-size: $AdditionTextSize;
            }
          }

          .Send {
            width: 0.4rem;
            height: 0.12rem;
            background-color: #fff;
            border-radius: 0.1rem;
            cursor: pointer;
            box-shadow: 5px 5px 15px #47478c;

            span {
              font-size: $SmallTextSize;
              color: #4848b8;
            }
          }
        }
      }

      .CodeWrap {
        width: 50%;

        i {
          width: 1rem;
          margin: 0.15rem auto 0;

          img {
            width: 100%;
          }
        }

        p {
          margin-top: 0.07rem;
          font-size: $SmallTextSize;
          color: #fff;
          text-align: center;
        }
      }
      /*.CodeWrap{*/
      /*  i{*/
      /*    width: 1rem;*/
      /*    margin: 0.4rem auto 0 !important;*/
      /*  }*/
      /*}*/
      .codes{
        background-color: transparent !important;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }

    .LoginTitle {
      width: 100%;
      margin-top: 0.05rem;

      p {
        font-size: $TextSize;
        color: #fff;
        text-indent: 0.05rem;
      }
    }
  }
  .FindPassword{
    position: relative;
    .Returns{
      width: 0.3rem;
      position: absolute;
      left: 0.1rem;
      bottom: 0.1rem;
      cursor: pointer;
      img{
        width: 100%;
      }
    }
    .InputContentWrap{
      margin-top: 0.1rem;
    }
    .CodeWrap{
      i{
        width: 1rem;
        margin: 0.4rem auto 0 !important;
      }
    }
  }
}
</style>
